import React from "react";

class ApMobileAnnotationsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { annotations, page } = this.props;

    const annotationItems = annotations.map(a => {
      if (a.for.document !== page.id) return null;
      return (
        <ListItem
          key={a.id}
          annotation={a}
          onSelect={() => this.props.onHighlightAnnotation(a.id)}
          ping={this.props.highlightedAnnotation === a.id}
        />
      );
    });

    return (
      <div
        className="ApMobileAnnotationsList"
        onTouchMove={e => {
          e.stopPropagation();
        }}
      >
        {annotationItems}
      </div>
    );
  }
}

function ListItem(props) {
  const classes =
    "ApMobileAnnotationItem" +
    (props.ping ? " ApMobileAnnotationItem-Active" : "");
  return (
    <div className={classes}>
      <p id="Name">Kunde</p>
      <p id="Text">{props.annotation.text}</p>
      <p id="Expand" className="Link" onClick={() => props.onSelect()}>
        Anzeigen
      </p>
    </div>
  );
}

export default ApMobileAnnotationsList;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileAnnotationsList.js